module.exports = __webpack_public_path__ + "0f2050bd7eabb90d28a66b54b23b9457.pdf";